module.exports = __webpack_public_path__ + "static/media/MF DOOM - Rhymes Like Dimes [HD].351267bc.mp3";